import { TrackingEvents } from "#webapp/src/util/analytics.util";
import { useGatewayMutation } from "@clockwise/web-commons/src/network/apollo/gateway-provider";
import { useTracking } from "@clockwise/web-commons/src/util/analytics.util";
import { UnpauseEventDocument } from "../../event-card/molecules/__generated__/UnpauseEvent.v2.generated";

export const useUnpauseEvent = (externalEventId: string | null) => {
  const track = useTracking();
  const [unpauseEvent, { loading: updating, error: updateError }] = useGatewayMutation(
    UnpauseEventDocument,
  );

  const update = async ({
    onCompleted,
    onError,
  }: {
    onCompleted?: () => void;
    onError?: () => void;
  }) => {
    if (!externalEventId) {
      onError?.();
      return;
    }

    track(TrackingEvents.DEFRAG.UNPAUSE_AUTOPILOT, {
      externalEventId,
    });

    await unpauseEvent({
      variables: {
        externalEventId,
      },
      onCompleted,
      onError,
    });
  };

  return {
    update,
    updating,
    updateError,
  };
};
